import React, { useState } from "react";
import {
  GptMessage,     // Componente para mostrar mensajes del asistente
  MyMessage,      // Componente para mostrar mensajes del usuario
  TypingLoader,   // Indicador de "escribiendo..."
  TextMessageBox  // Componente de input para enviar mensajes
} from "./index";
import { Assistant_createquestion } from "../../api/AssistantEducaAPI";
import { useAuth } from "../../hooks";

/**
 * Componente de Chat
 * Recibe:
 * - assistantId: El ID de la asistencia
 * - avatarImg: URL de la imagen del asistente
 * - saludo: Texto de saludo inicial
 * - threadId: El ID del hilo (creado por el componente padre)
 */
export function AssistantEducaChat({ assistantId, avatarImg, saludo, threadId }) {
  //console.log("AssistantEducaChat -> threadId:", threadId);
  //console.log("AssistantEducaChat -> assistantId:", assistantId);
  const [isLoading, setIsLoading] = useState(false);
  const [messages, setMessages] = useState([]);
  const { accessToken } = useAuth();

  // Maneja el envío de mensajes
  const handlePost = async (text) => {
    // Si no existe un threadId, no enviamos nada
    if (!threadId) return;

    // Agregamos el mensaje del usuario
    setIsLoading(true);
    setMessages((prev) => [...prev, { text, isGpt: false }]);

    try {
      // Llamada a la API para enviar la pregunta
      const replies = await Assistant_createquestion(
        accessToken,
        threadId,
        assistantId,
        text
      );
      setIsLoading(false);

      // Filtrar la última respuesta del asistente
      let lastAssistantMessage = null;
      for (const reply of replies) {
        if (reply.role === "assistant") {
          lastAssistantMessage = reply.content[reply.content.length - 1];
        }
      }

      // Agregar la respuesta del asistente
      if (lastAssistantMessage) {
        setMessages((prev) => [...prev, { text: lastAssistantMessage, isGpt: true }]);
      }
    } catch (error) {
      console.error("Error al enviar la pregunta:", error);
      setIsLoading(false);
    }
  };

  return (
    <div className="chat-container">
      <div className="chat-messages">
        <div className="grid grid-cols-12 gap-y-2">
          {/* Mensaje inicial del asistente */}
          <GptMessage
            text={`Hola soy ${saludo}. ¿En qué puedo ayudarte?`}
            imageAvatar={avatarImg}
          />

          {/* Mensajes del chat */}
          {messages.map((message, index) =>
            message.isGpt ? (
              <GptMessage key={index} text={message.text} imageAvatar={avatarImg} />
            ) : (
              <MyMessage key={index} text={message.text} />
            )
          )}

          {/* Loader mientras el asistente responde */}
          {isLoading && (
            <div className="col-start-1 col-end-12 fade-in">
              <TypingLoader />
            </div>
          )}
        </div>
      </div>

      {/* Caja de texto para enviar mensajes */}
      <TextMessageBox
        onSendMessage={handlePost}
        placeholder="Escribe aquí tu pregunta..."
        disableCorrections
      />
    </div>
  );
}
